import { render, staticRenderFns } from "./anchorRoom.vue?vue&type=template&id=17c5a99a&scoped=true"
import script from "./anchorRoom.vue?vue&type=script&lang=js"
export * from "./anchorRoom.vue?vue&type=script&lang=js"
import style0 from "./anchorRoom.vue?vue&type=style&index=0&id=17c5a99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c5a99a",
  null
  
)

export default component.exports